import { render, staticRenderFns } from "./service-management.vue?vue&type=template&id=5dd99278&scoped=true&"
import script from "./service-management.vue?vue&type=script&lang=js&"
export * from "./service-management.vue?vue&type=script&lang=js&"
import style0 from "./service-management.vue?vue&type=style&index=0&id=5dd99278&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd99278",
  null
  
)

export default component.exports